export default "__VITE_ASSET__CCR$zAkS__"